import { observable, computed, runInAction } from 'mobx';
import { post } from '../utils';

class SearchSort {
    static PAGE_SIZE = 20;
    private route: string;
    private params: any;

    @observable
    public firstFetched: boolean = false;
    @observable
    public isEmpty: boolean = false;
    @observable
    public lists: any[] = [];
    @observable
    public page: any = 1;
    @observable
    public isReady: boolean = false;
    @observable
    public cursor: any = '';// 是否有下一页
    @observable
    private isLastPage: boolean = true;

    constructor(params: any) {
        this.route = params.url;
        this.params = params;
    }

    @computed
    get canFetch() {
        if (this.isEmpty) {
            return false;
        }
        return !this.isLastPage;
    }

    async fetch(page, callback, errs?) {
        var obj = Object.assign({
            count: SearchSort.PAGE_SIZE,
            cursor: this.cursor
        }, this.params);
        if (this.cursor == null && page != 1) {
            return callback && callback([], null); //返回库存和页码
        }
        if (page == 1) {
            obj.cursor = 0;
        }
        post(this.route, obj).then((d) => {
            this.isReady = true;
            let data;
            if (d.data) {
                data = d.data.list;
                this.cursor = d.data.cursor;
                callback && callback(data, this.cursor);
                runInAction(() => {
                    if (page == 1) {
                        this.lists = [];
                        this.isEmpty = data.length == 0;
                    }
                    this.firstFetched = true;
                    this.isLastPage = data.length < SearchSort.PAGE_SIZE;
                    data.forEach((item) => {
                        item.key = item.ciId + '' + Date.now();
                        this.lists.push(item);
                    });
                });
            } else {
                callback && callback([]);
                this.firstFetched = true;
            }
        }).catch((err) => {
            errs && errs(err);
        });
    }

    @computed
    get list() {
        return this.lists.slice();
    }
}

export default SearchSort;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/SearchSort.ts